<rb-auth-container [title]="'LOGOUT.TITLE'">
  <ng-container *ngIf="officeId === null">
    <p class="text-center">{{ 'LOGOUT.MESSAGE' | translate }}</p>
    <button (click)="login()"
            [disableRipple]="true"
            class="button-auth0 mt-[2.4rem] text-white w-full"
            mat-flat-button>{{ 'LOGOUT.BUTTON' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="officeId !== null">
    <div class="flex flex-col items-center">
      <mat-spinner class="spinner-brand" diameter="20"></mat-spinner>
    </div>
  </ng-container>
</rb-auth-container>
